<template>
    <div class="my-table">
        <b-row>
            <b-col cols="4" class="m-0">
                <b-form-group size="sm"
                              label="Filter"
                              label-cols-sm="2"
                              label-align-sm="left"
                              label-size="sm"
                              label-for="filterInput"
                              class="mb-0"
                >
                    <b-input-group>
                        <b-form-input
                                size="sm"
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="NodeID"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button size="sm" :disabled="!filter" @click="filter = ''">X</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4" class="m-0">
                <b-form-group
                        label="Filter on"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        description="Leave all unchecked to filter on both columns"
                        class="mb-0">
                    <b-form-checkbox-group v-model="filterOn">
                        <b-form-checkbox value="templateID">Template ID</b-form-checkbox>
                        <b-form-checkbox  value="candidateID">Candidate ID</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-pagination
                        size="sm"
                        align="right"
                        v-model="currentPage"
                        :total-rows="items.length"
                        :per-page="perPage"
                        aria-controls="my-table"
                ></b-pagination>
            </b-col>
        </b-row>
        <b-table small striped hover :items="items"
                 :sort-by.sync="sortBy" :sort-desc="sortDesc" :sort-null-last="true"
                 :sort-compare-options="{ numeric: true }"
                 :per-page=perPage :current-page=currentPage :no-provider-paging="true"
                 :fields="fields" bordered :sticky-header=true responsive="sm" class="my-table"
                 selectable select-mode="single" @row-selected="onRowSelected"
                 :filter="filter" :filterIncludedFields="filterOn" :filter-function="filterFunc">
        </b-table>
    </div>
</template>

<script>


    const DISTANCE_FIELD_OPTIONS = {
        sortable: true,
        formatter: "decimalFormatter",
        tdClass: "cellStyle"
    }
    export default {
        name: "DistanceTableView",
        props: ["items", "metrics"],
        data() {
            return {
                perPage: 8,
                currentPage: 1,
                filter: null,
                filterOn: [],
                selected: null,
                sortBy: 'demographicsCosine',
                sortDesc: false,
                fields: [
                    {key: 'templateID', sortable: false, stickyColumn: true},
                    {key: 'candidateID', sortable: false, stickyColumn: true}

                ],
            }
        },
        mounted() {
            this.fields = this.fields.concat(this.metrics.map(field => {
                return {
                    key: field,
                    ...DISTANCE_FIELD_OPTIONS
                }
            }))
        },
        methods: {
            filterFunc(item, filter) { // Exact match is faster than  default function
                return (item.templateID.toString() === filter || item.candidateID.toString() === filter)
            },
            onRowSelected(items) {
                if (items.length > 0 && items[0]) {
                    this.selected = items[0]
                    this.$emit('selected', {
                        "templateID": this.selected.templateID,
                        "candidateID": this.selected.candidateID,
                        "distances": this.selectionDistance()
                    });
                }
            },
            cellStyle(value) {
                if (value === 0 || value) {
                    return "scale-color-" + Math.max((7 - Math.floor((value * 7.))), 1)
                } else
                    return ""
            },
            decimalFormatter(value) {
                if (value !== null)
                    return value.toFixed(3)
                else
                    return "-"
            },
            selectionDistance() {
                if (!this.selected) return undefined
                return this.metrics.map(field => this.selected[field])
            }
        }
    }
</script>

<style>
    .my-table {
        font-size: small;
    }

    .scale-color-1 {
        background-color: #d93a46;
    }

    .scale-color-2 {
        background-color: #e98e95;
    }

    .scale-color-3 {
        background-color: #fae6e7;
    }

    .scale-color-4 {
        background-color: #e9f2f5;
    }

    .scale-color-5 {
        background-color: #e9f2f5;
    }

    .scale-color-6 {
        background-color: #93b8c3;
    }

    .scale-color-7 {
        background-color: #3f7f93;
    }
</style>
